module.exports = __webpack_public_path__ + "img/video_code.4bd7ca8c.jpg";